import React, { Ref, forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import './index.css'
import BadgesComponent from '@components/common/Badges';
import CommonFormFields from '@pages/Forms/CommonFormFields';
import { beneficiaryPersonalDetails } from '@constants/index';
import endpoints from '@config/endpoints';
import { useNavigate, useParams } from 'react-router-dom';
import { getData, postDataJSON, getDataWithCache, putDataJSON } from '../../../../services/CommonApiService';
import { useSelector } from 'react-redux';
import { RootState } from '@store/reducers';
import { updateForm } from '@store/actions/userManagementAction';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { imageData, isBeneficiaryModified, isImageEdited, setAadhar, setAbhaAddress, setBeneficiaryAbha, setBeneficiaryAuthType, setBeneficiaryData, setBeneficiaryDetails, setBeneficiaryGender, setBeneficiaryMobileNumber, setBeneficiaryPregnancyHistory, setBeneficiaryRedgOption, setBenfDeathDetails, setBenfId, setIsHRP, setIsPregnant, setTsnID, setTxnIdForAbhaAddress, updateChild, updateDeliveryDetails } from '@store/actions/beneficiaryAction';
import axios from '@utils/axiosExt';
import Auth from '@utils/auth';
import { errorLogger } from '@utils/applicationLogUtils';
import Unauthorised from '@components/Auth/Unauthorised';
import Button from '@components/common/Button';
import OTPVerification from '@pages/Beneficiary-block/CreateBeneficiary/OTP';
import BeneficiaryRedgeOptionModal from '@pages/Beneficiary-block/CreateBeneficiary/BeneficiaryRedgeOptionModal';
import AuthenticationOptionModal from '@pages/Beneficiary-block/CreateBeneficiary/AuthenticationOptionModal';
import VerificationModal from '@pages/Beneficiary-block/CreateBeneficiary/VerificationModal';
import Demographic from '@pages/Beneficiary-block/CreateBeneficiary/Demographic';
import BenefeciaryUnderMobNo from '@pages/Beneficiary-block/CreateBeneficiary/BenefeciaryUnderMobNo';
import { decodeWithKeyAndShift, encodeWithKeyAndShift } from '@utils/base64Utils';
import { buttonNames, smsNotificationConstants } from '@constants/appConstants';
import { benef_const } from '@constants/beneficiaryConstant';
import BeneficiaryExistsModal from '@pages/Beneficiary-block/CreateBeneficiary/BeneficiaryExistsModal';
import FaceAuthenticationOptionsModal from '@pages/Beneficiary-block/CreateBeneficiary/FaceAuthenticationOptionsModal';
import FaceAuthenticationModal from '@pages/Beneficiary-block/CreateBeneficiary/FaceAuthenticationModal';
import ReAuthenticationModal from '@pages/Beneficiary-block/CreateBeneficiary/FaceAuthentication/ReAuthenticationModal';
import { createDateString, formatAbhaNumber, prepareBeneficiaryImageForDisplay } from '@utils/childUtils';
import beneficiaryReduxStoreRemovalUtils from '@utils/beneficiaryReduxStoreRemovalUtils';
import BeneficiaryMobileNumberUpdation from './BenefMobileNumberUpdation';
import { formatDobForApi, parseDobToIstDayjs } from '@utils/dateFormatView';



export interface ChildComponentHandlerUpdateBeneficiary {
    handleUpdateSave: () => void;
}

export interface objectType {
    beneficiaryDetails: any
}

const BeneficiaryEdit = forwardRef((props: objectType, ref: Ref<ChildComponentHandlerUpdateBeneficiary>) => {
    const userId = localStorage.getItem('userId');
    const { beneficiaryDetails } = props
    const navigate = useNavigate();
    const imageDetails = useSelector((state: RootState) => state.beneficiary.imageData);
    const benfDetails = useSelector((state: RootState) => state.beneficiary.beneficiaryDetails);
    const [showRedgOptionBeneficiary, setShowRedgOptionBeneficiary] = useState(false);
    const [showAuthBeneficiary, setShowAuthBeneficiary] = useState(false);
    const [showFaceAuthOptionsModal, setShowFaceAuthOptionsModal] = useState(false);
    const [showFaceAuthModal, setShowFaceAuthModal] = useState(false);
    const [isFaceAuthenticated, setIsFaceAuthenticated] = useState(false);
    const [showReAuthModal, setShowReAuthModal] = useState(false);
    const [abdmDataForReAuth, setAbdmDataForReAuth] = useState<any>(null);
    const [facilityDetails, setFacilityDetails] = useState<any>([]);
    const userDetail = JSON.parse(decodeWithKeyAndShift(localStorage.getItem('userDetails')));
    const roleDetails=JSON.parse(decodeWithKeyAndShift(localStorage.getItem('userRoleDetails')));
    const [ufId, setUfId] = useState<string>('');
    const [userType, setUserType] = useState<string>('')
    const [userName, setUserName] = useState<string>('')
    const [urbanRural, setUrbanRural] = useState<string>('');
    const [showVerificationBeneficiary, setShowVerificationBeneficiary] = useState(false);
    const [showBenefeciaryUnderMobNoModal, setShowBenefeciaryUnderMobNoModal] = useState(false)
    const [linkedBenefDetails, setLinkedBenefDetails] = useState<string>('');
    const [showExistsModal, setShowExistsModal] = useState(false);
    const isImageModified = useSelector((state: RootState) => state.beneficiary.isImageEdited);
    const [beneficiaryPersonalDetailsData, setBeneficiaryPersonalDetailsData] = useState<any>(beneficiaryPersonalDetails);
    const getBeneficiaryData = useSelector((state: RootState) => state.beneficiary);
    const [consentLanguageData,setConsentLanguageData]=useState<any>([]);
    const abhaAddressFromStore  = useSelector((state: RootState) => state.beneficiary.abhaAddress);
    const [facilityDetailsChanged, setFacilityDetailsChanged] = useState<boolean>(false);
    const [beneficiaryServiceProviderData, setBeneficiaryServiceProviderData] = useState<any>({
        healthProviderName: {
            '#type': 'select',
            '#title': 'Health Provider Name',
            '#webform_key': 'healthProviderName',
            '#required': false,
            '#isDisabled': true,
            '#options': [],
        },
        mobiliserName: {
            '#type': 'select',
            '#title': 'Asha /Mobiliser Name',
            '#webform_key': 'mobiliserName',
            '#required': false,
            '#isDisabled': true,
            '#options': [],
        },
    })
    const [beneficiaryFacilityDetailsData, setBeneficiaryFacilityDetailsData] = useState<any>({
        facilityType: {
            '#type': 'select',
            '#title': 'Facility Type',
            '#webform_key': 'facilityType',
            '#required': true,
            '#options': [],
        },

        facilityName: {
            '#type': 'select',
            '#title': 'Facility Name',
            '#webform_key': 'facilityName',
            '#required': true,
            '#options': [],
        }
    })
    const [beneficiaryPersonalDetailsForm, setBeneficiaryPersonalDetailsForm] = useState<any>({
        abhaId: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
        },
        abhaAddress: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
        },
        name: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
        },
        dob: {
            isError: false,
            message: '',
            id: '',
            isDisable: false,
            value: '',

        },
        primaryMob: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
        },
        address: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
        },
        sName: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
        },
        caste: {
            isError: false,
            message: '',
            isDisable: false,
            value: null,
        },
        Religion: {
            isError: false,
            message: '',
            isDisable: false,
            value: null,
        },
        other_religion: {
            isError: false,
            message: '',
            isDisable: false,
            value: null,
        },
        aNumber: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
        },
        aadharId: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
        },

        sms: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
        },
        pvtg: {
            isError: false,
            message: '',
            isDisable: true,
            value: false,
        },
        village: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
        },
        state: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
            id:'',
            code:''
        },
        district: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
            id:'',
            code:''
        },
        rch1Id: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
            id:'',
            code:''
        },
        ward: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
        }
    })
    const [beneficiaryServiceProviderForm, setBeneficiaryServiceProviderFrom] = useState<any>({
        healthProviderName: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
        },

        mobiliserName: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
        },
    })
    const [beneficiaryFacilityDetailsForm, setBeneficiaryFacilityDetailsForm] = useState<any>({

        facilityType: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
        },
        facilityName: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
        },
    })
    const [initialHealthProviderId, setInitialHealthProviderId] = useState<string>('')
    const [initialMobiliserId, setInitialMobiliserId] = useState<string>('')
    let isBenefHasFacilityData=false;
    let isBenefHasServiceData=false;
    let isBenefHasPoshanData=false;
    const beneficiaryStoreData = useSelector((state: RootState) => state.beneficiary);
    const getBenfData = useSelector((state: RootState) => state.beneficiary.beneficiaryData);
    const [beneficiary, setBeneficiary] = useState<any>();
    const [showUnauthorized, setShowUnauthorized] = useState<boolean>(false);
    const [isAbhaExists, setIsAbhaExists] = useState<boolean>(false);
    const [showOTP, setShowOTP] = useState(false);
    const [showDemographicModal, setShowDemographicModal] = useState(false);
    const [showEditMobileNumberModal, setShowEditMobileNumberModal] = useState(false);
    const [oldMobileNumber, setOldMobileNumber] = useState<string>('');
    const [loginId, setLoginId] = useState<string>('');
    const dispatch = useDispatch();
    const { id } = useParams()

    useImperativeHandle(ref, () => ({

        handleUpdateSave() {
            onHandleSave();

        }
    }));
    useEffect(() => {
        const fetchData = async () => {
            const storeData:any={};
            storeData.data=benfDetails;
            const response =benfDetails?.length>0 ? storeData : await getData<any>(`${endpoints.getBeneficiaryById}/${id}`);
            if (response.data.length === 0) {
                setShowUnauthorized(true);
            }
            else {
                setShowUnauthorized(false);
                setBeneficiary(response.data[0]);
                dispatch(setBeneficiaryDetails(response.data));
                dispatch(updateDeliveryDetails('parentAbha', response?.data[0]?.abha_id));
                if (response.data[0].abha_id) {
                    setBeneficiaryPersonalDetailsData((prevState: any) => {
                        return {
                            ...prevState,
                            ['number']: {
                                ...prevState['number'],
                                '#isDisabled': true,
                                '#showEditIconInInputField': true
                            }
                        }
                    })
                }
                else {
                    setBeneficiaryPersonalDetailsData((prevState: any) => {
                        return {
                            ...prevState,
                            ['number']: {
                                ...prevState['number'],
                                '#isDisabled': false,
                                '#required': false
                            }
                        }
                    })
                }

                if (response.data[0].abha_id && response.data[0].abha_address) {
                    setBeneficiaryPersonalDetailsData((prevState: any) => ({
                        ...prevState,
                        ['abhaAddress']: {
                            ...prevState['abhaAddress'],
                            '#type':'textfield',
                        },
                    }));
                    setBeneficiaryPersonalDetailsForm((prevState: any) => ({
                        ...prevState,
                        ['abhaAddress']: {
                            ...prevState['abhaAddress'],
                            value: response.data[0].abha_address,
                        },
                    }));
                }
                else {
                    setBeneficiaryPersonalDetailsForm((prevState: any) => ({
                        ...prevState,
                        ['abhaAddress']: {
                            ...prevState['abhaAddress'],
                            value: '',
                        },
                    }));

                }
                const staticBenfCreateDetails = await getDataWithCache<any>(`${endpoints.getStaticBenfCreateDetails}`);
                setBeneficiaryPersonalDetailsData((prevState: any) => {
                    return {
                        ...prevState,
                        ['caste']: {
                            ...prevState['caste'],
                            '#options': staticBenfCreateDetails?.data.categoryData.map((key: any) => ({
                                value: key.category_name,
                                label: key.category_name,
                                id: key.category_id,
                                code: key.category_code
                            }))
                        }
                    }
                })
                const religion = staticBenfCreateDetails?.data.religionData[0].map((key: any) => ({
                    value: key.religion_name,
                    label: key.religion_name,
                    id: key.religion_id,
                    code: key.religion_code
                }));
                setBeneficiaryPersonalDetailsData((prevState: any) => {
                    return {
                        ...prevState,
                        ['Religion']: {
                            ...prevState['Religion'],
                            '#options': religion
                        }
                    }
                })
                setBeneficiaryPersonalDetailsData((prevState: any) => {
                    return {
                        ...prevState,
                        ['village']: {
                            ...prevState['village'],
                            '#isDisabled': !response.data[0]?.village_name,
                            value: response.data[0]?.village_name || '',
                        },
                        ['ward']: {
                            ...prevState['ward'],
                            '#isDisabled': !response.data[0]?.ward_name,
                            value: response.data[0]?.ward_name || '',
                        }
                    };
                });
                if (beneficiaryStoreData.beneficiaryRedgeOption == 'Face_Authentication') {
                    setLoginId(staticBenfCreateDetails.data.loginProcessData[4].login_process_id)
                }
                else if (beneficiaryStoreData.beneficiaryRedgeOption == 'Aadhaar') {
                    setLoginId(staticBenfCreateDetails.data.loginProcessData[1].login_process_id)
                }
                else if (beneficiaryStoreData.beneficiaryRedgeOption == 'ABHA') {
                    setLoginId(staticBenfCreateDetails.data.loginProcessData[0].login_process_id)
                }
                else if (beneficiaryStoreData.beneficiaryRedgeOption == 'Phone_Number') {
                    setLoginId(staticBenfCreateDetails.data.loginProcessData[2].login_process_id)
                }
                else if (beneficiaryStoreData.beneficiaryRedgeOption == 'Temporary_Registration') {
                    setLoginId(staticBenfCreateDetails.data.loginProcessData[3].login_process_id)
                }
            }
        }
        fetchData();

        const clearStates = () => {
            dispatch(updateChild('imageUrl', ''));
            dispatch(updateChild('beneficiaryUpdateDetails', {}));
        };

        const handleBeforeUnload = () => {
            clearStates();
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            clearStates();
            window.removeEventListener('beforeunload', handleBeforeUnload);
        }
    }, []);

    useEffect(()=>{
        if(beneficiaryPersonalDetailsForm?.abhaId?.value && beneficiaryPersonalDetailsForm?.abhaAddress?.value){
            if(beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.aadhar && beneficiaryStoreData.beneficiaryAuthType === benef_const.verifyOptions.otp){
                const [abhaNumber, suffixPart] = (beneficiaryPersonalDetailsForm?.abhaAddress?.value ?? '').split('@');
                const suffix = suffixPart ? '@' + suffixPart : '@sbx';
                setBeneficiaryPersonalDetailsData((prevState: any) => ({
                    ...prevState,
                    ['abhaAddress']: {
                        ...prevState['abhaAddress'],
                        '#type':'InputFieldWithSuffix',
                        '#isVisible':true,
                        '#isDisabled': true,
                        '#isBtnDisabled':false,
                        '#suffix':suffix
                    },
                }));
                setBeneficiaryPersonalDetailsForm((prevState: any) => ({
                    ...prevState,
                    ['abhaAddress']: {
                        ...prevState['abhaAddress'],
                        value: abhaNumber,
                    },
                }));
            }
        else {
            setBeneficiaryPersonalDetailsData((prevState: any) => ({
                ...prevState,
                ['abhaAddress']: {
                    ...prevState['abhaAddress'],
                    '#type':'textfield',
                    '#isVisible':true,
                    '#isDisabled': true,
                },
            }));
            setBeneficiaryPersonalDetailsForm((prevState: any) => ({
                ...prevState,
                ['abhaAddress']: {
                    ...prevState['abhaAddress'],
                    value: beneficiaryPersonalDetailsForm?.abhaAddress?.value,
                },
            }));
        }
    }else{
        setBeneficiaryPersonalDetailsData((prevState: any) => ({
            ...prevState,
            ['abhaAddress']: {
                ...prevState['abhaAddress'],
                '#type':'textfield',
                '#isVisible':true,
                '#isDisabled': true,
            },
        }));
        setBeneficiaryPersonalDetailsForm((prevState: any) => ({
            ...prevState,
            ['abhaAddress']: {
                ...prevState['abhaAddress'],
                value: ''
            },
        }));
    }
    },[beneficiaryPersonalDetailsForm.abhaId.value])

    useEffect(()=>{
        if(abhaAddressFromStore){
            setBeneficiaryPersonalDetailsData((prevState: any) => ({
                ...prevState,
                ['abhaAddress']: {
                    ...prevState['abhaAddress'],
                    '#type':'textfield',
                    '#isVisible':true,
                    '#isDisabled': true,
                },
            }));
            setBeneficiaryPersonalDetailsForm((prevState: any) => ({
                ...prevState,
                ['abhaAddress']: {
                    ...prevState['abhaAddress'],
                    value: abhaAddressFromStore,
                },
            }));
        }
        
    },[abhaAddressFromStore])
    

    useEffect(() => {
        if (beneficiaryPersonalDetailsForm.caste.value) {
            if (beneficiaryPersonalDetailsForm.caste.value !== 'ST') {
                delete beneficiaryPersonalDetailsData.pvtg
                setBeneficiaryPersonalDetailsForm((prevState: any) => ({
                    ...prevState,
                    ['pvtg']: {
                        ...prevState['pvtg'],
                        value: false,
                        isError: false,
                        message: ''
                    },
                }))
            }
            else {
                setBeneficiaryPersonalDetailsData((prevState: any) => {
                    return {
                        ...prevState,
                        pvtg: {
                            '#type': 'radioButton',
                            '#title': 'Is PVTG Classified',
                            '#webform_key': 'pvtg',
                            '#required': true,
                            '#isDisabled': false,
                            '#group': 'beneficiaryEdit',
                            '#options': [buttonNames.yes, buttonNames.no]
                        }
                    }
                })
                setBeneficiaryPersonalDetailsForm((prevState: any) => ({
                    ...prevState,
                    ['pvtg']: {
                        ...prevState['pvtg'],
                        value: beneficiary?.is_pvtg_classified ? buttonNames.yes : buttonNames.no,
                        isError: false,
                        message: ''
                    },
                }))
            }
        }
    }, [beneficiaryPersonalDetailsForm.caste.value])

    useEffect(() => {
        if (beneficiaryPersonalDetailsForm.Religion.value !== 'Others') {
            setBeneficiaryPersonalDetailsData((prevState: any) => {
                return {
                    ...prevState,
                    ['other_religion']: {
                        ...prevState['other_religion'],
                        '#isDisabled': true,
                        '#required': false,
                    }
                }
            })
            setBeneficiaryPersonalDetailsForm((prevState: any) => ({
                ...prevState,
                ['other_religion']: {
                    ...prevState['other_religion'],
                    value: '',
                    isError: false,
                    message: ''
                },
            }))
        }
        else {
            setBeneficiaryPersonalDetailsData((prevState: any) => {
                return {
                    ...prevState,
                    ['other_religion']: {
                        ...prevState['other_religion'],
                        '#isDisabled': false,
                        '#required': true,
                    }
                }
            })
            setBeneficiaryPersonalDetailsForm((prevState: any) => ({
                ...prevState,
                ['other_religion']: {
                    ...prevState['other_religion'],
                    isError: false,
                    message: ''
                },
            }))
        }
    }, [beneficiaryPersonalDetailsForm.Religion.value])

    useEffect(() => {
        if (beneficiary) {
            setOldMobileNumber(beneficiary?.mob);
            setIsFaceAuthenticated(beneficiary?.is_face_authenticated ?? false);
            setBeneficiaryPersonalDetailsForm((prevState: any) => ({
                ...prevState,
                abhaId: {
                    ...prevState.abhaId,
                    value: beneficiary?.abha_id
                },
                abhaAddress: {
                    ...prevState.abhaAddress,
                    value: beneficiary?.abha_address
                },
                name: {
                    ...prevState.name,
                    value: beneficiary?.benf_name
                },
                primaryMob: {
                    ...prevState.primaryMob,
                    value: beneficiary?.mob
                },
                dob: {
                    ...prevState.dob,
                    value: parseDobToIstDayjs(beneficiary?.dob),
                },
                sms: {
                    ...prevState.sms,
                    value: beneficiary?.enroll_for_sms
                },

                pvtg: {
                    ...prevState.pvtg,
                    value: beneficiary?.is_pvtg_classified ? buttonNames.yes : buttonNames.no
                },
                aNumber: {
                    ...prevState.aNumber,
                    value: beneficiary?.alternate_mob
                },
                caste: {
                    ...prevState.caste,
                    value: beneficiary?.category_name,
                    id: beneficiary?.category_id
                },
                sName: {
                    ...prevState.sName,
                    value: beneficiary?.spouse_name
                },
                address: {
                    ...prevState.address,
                    value: beneficiary?.abha_address
                },
                Religion: {
                    ...prevState.Religion,
                    value: beneficiary?.religion_name,
                    id: beneficiary?.religion_id
                },
                other_religion: {
                    ...prevState.other_religion,
                    value: beneficiary?.other_religion,
                },
                village: {
                    ...prevState.village_name,
                    value: beneficiary?.village_name,
                },
                ward: {
                    ...prevState.ward_name,
                    value: beneficiary?.ward_name,
                },
                state: {
                    ...prevState.state,
                    value: `${beneficiary?.state_name}-${beneficiary?.state_code}`,
                    id: beneficiary?.state_id,
                    code:beneficiary?.state_code
                },
                district: {
                    ...prevState.district,
                    value: `${beneficiary?.dist_name}-${beneficiary?.dist_code}`,
                    id: beneficiary?.dist_id,
                    code:beneficiary?.dist_code
                },
                rch1Id: {
                    ...prevState.rch1Id,
                    value: beneficiary?.rch_id,
                },

            }))
            if(beneficiary?.rch_id){
                 setBeneficiaryPersonalDetailsData((prevState: any) => ({
                ...prevState,
                ['rch1Id']: {
                    ...prevState['rch1Id'],
                    '#isVisible': true,
                },
            }))
            }
           if(beneficiary?.healthprovider_id?.length>0 ? true : false){
            setBeneficiaryServiceProviderFrom((prevState: any) => ({
                ...prevState,
                healthProviderName: {
                    ...prevState.healthProviderName,
                    value: beneficiary?.health_provider_name ? beneficiary?.health_provider_name[0] : '',
                    id: beneficiary.healthprovider_id ? beneficiary.healthprovider_id[0] : '    '
                },
                mobiliserName: {
                    ...prevState.mobiliserName,
                    value: beneficiary?.mobiliser_f_name ? beneficiary?.mobiliser_f_name?.[0] : '',
                    id: beneficiary?.mobiliser_id ? beneficiary?.mobiliser_id[0] : ''
                },

            }))
            }
            setUrbanRural(userDetail.urban_rural_name);
            setUserType(userDetail.usertype_name);
            setUserName(userDetail.first_name + ' ' + userDetail.middle_name + ' ' + userDetail.last_name);
            setInitialHealthProviderId(beneficiary?.healthprovider_id ? beneficiary?.healthprovider_id[0] : '');
            setInitialMobiliserId(beneficiary?.mobiliser_id ? beneficiary?.mobiliser_id[0] : '');
            if(beneficiary?.facility_id?.length>0 ? true : false){
            setBeneficiaryFacilityDetailsForm((prevState: any) => ({
                ...prevState,
                facilityType: {
                    ...prevState.facilityType,
                    value: beneficiary?.facility_type,
                    id: beneficiary?.facility_type_id ? beneficiary?.facility_type_id[0] : ''
                },
                facilityName: {
                    ...prevState.facilityName,
                    value: beneficiary?.facility_name,
                    id: beneficiary?.facility_id ? beneficiary?.facility_id[0] : ''
                },

            }))
            }
            isBenefHasServiceData=beneficiary?.healthprovider_id?.length>0 ? true : false;
            isBenefHasFacilityData=beneficiary?.facility_id?.length>0 ? true : false;
            isBenefHasPoshanData=beneficiary?.source_name === 'poshan';
            if(!isBenefHasServiceData && isBenefHasPoshanData ? true : !isBenefHasFacilityData){
                fetchFacilityData();
            }
            else{
                setBeneficiaryFacilityDetailsData((prevState: any) => {
                    return {
                      ...prevState,
                      ['facilityName']: {
                        ...prevState['facilityName'],
                        '#isDisabled': true
                      },
                      ['facilityType']: {
                        ...prevState['facilityType'],
                        '#isDisabled': true,
                      }
                    }
                }) 
            }
            dispatch(setBenfId(beneficiary.benef_id));
        }
    }, [beneficiary])

    const fetchFacilityData = async () => {
      const facility_details_response = await getDataWithCache<any>(`${endpoints.getLinkedFacilitiesByUserById}/${userId}`);
      setFacilityDetails(facility_details_response.data[0]);
      const parentFacility = facility_details_response.data[0].find((item: any) => item.is_parent === true);
      setBeneficiaryFacilityDetailsForm((prevState: any) => ({
        ...prevState,
        ['facilityName']: {
          ...prevState['facilityName'],
          value: parentFacility?.facility_name,
          id: parentFacility?.facility_id
        },
        ['facilityType']: {
          ...prevState['facilityType'],
          value: parentFacility?.facility_type_name,
          id: parentFacility?.facility_type_id
        }

      }))
      let facilityIdToGetProvider=parentFacility?.facility_id
      setBeneficiaryFacilityDetailsData((beneficiary_facilitydetails: { healthProviderName: any, facilityName: any, mobiliserName: any, ward: any, village: any }) => ({
        ...beneficiary_facilitydetails,
        facilityName: {
          ...beneficiary_facilitydetails.facilityName,
          '#options': facility_details_response.data[0]?.map((key: any) => ({
            value: key.facility_name,
            label: key.facility_name,
            id: key.facility_id
          })),
          '#isDisabled': facility_details_response.data[0]?.length=== 1 ? true : false
        }
      }));

      if (facility_details_response.data[0].length === 1) {
        facilityIdToGetProvider=facility_details_response.data[0][0].facility_id;
        setBeneficiaryFacilityDetailsForm((prevState: any) => ({
          ...prevState,
          ['facilityName']: {
            ...prevState['facilityName'],
            value: facility_details_response.data[0][0].facility_name,
            id: facility_details_response.data[0][0].facility_id
          },
          ['facilityType']: {
            ...prevState['facilityType'],
            value: facility_details_response.data[0][0].facility_type_name,
            id: facility_details_response.data[0][0].facility_type_id
          }
        }))
      }
      facilityIdToGetProvider?.trim() && fetchHealthProviderData(facilityIdToGetProvider);
      if(userDetail.usertype_name === 'Field Level User'){
        setBeneficiaryServiceProviderData((beneficiary_facilitydetails: { mobiliserName: any }) => ({
            ...beneficiary_facilitydetails,
            ['mobiliserName']: {
                ...beneficiary_facilitydetails['mobiliserName'],
                '#isDisabled': true,
            }
        }));
    }
    else{
        setBeneficiaryServiceProviderData((beneficiary_facilitydetails: { mobiliserName: any }) => ({
            ...beneficiary_facilitydetails,
            ['mobiliserName']: {
                ...beneficiary_facilitydetails['mobiliserName'],
                '#isDisabled': false,
            }
        }));
    }
    if(roleDetails?.includes('Administrator')){
     setBeneficiaryServiceProviderData((beneficiary_facilitydetails: { healthProviderName: any }) => ({
            ...beneficiary_facilitydetails,
            ['healthProviderName']: {
                ...beneficiary_facilitydetails['healthProviderName'],
                '#isDisabled': false,
            }
        }));
    }
    else{
       setBeneficiaryServiceProviderData((beneficiary_facilitydetails: { healthProviderName: any }) => ({
            ...beneficiary_facilitydetails,
            ['healthProviderName']: {
                ...beneficiary_facilitydetails['healthProviderName'],
                '#isDisabled': true,
            }
        }));
    }
      const facilityTypes = facility_details_response?.data[0]?.map((key: any) => ({
        value: key.facility_type_name,
        label: key.facility_type_name,
        id: key.facility_type_id
      }));
      const filteredFacilityType = facilityTypes.filter((obj: any, index: any) => {
        return index === facilityTypes.findIndex((o: any) => obj.value === o.value);
      })
    setBeneficiaryFacilityDetailsData((prevState: any) => {
        return {
          ...prevState,
          ['facilityType']: {
            ...prevState['facilityType'],
            '#options': filteredFacilityType,
            '#isDisabled': facilityTypes?.length=== 1 ? true : false
          }
        }
      })
    }
    const isValueContainsOnlyDigits = (value: any) => {
        return /^\d*$/.test(value);
    };
    const handlePersonalDetailsFormChange = (value: any, key: string, id: any, option: any, code: any,) => {
        if((key==="primaryMob" || key==='aNumber') &&(!isValueContainsOnlyDigits(value)||value.length>10 )){
            return
        }
        setBeneficiaryPersonalDetailsForm((prevState: any) => ({
            ...prevState,
            [key]: {
                ...prevState[key],
                value: value,
                isError: false,
                message: '',
                id: id,
                code: code
            },
        }))   
    }
    const handleServiceDetailsFormChange = (value: any, key: string, id: any, option: any, code: any,) => {
        if (value && key === 'healthProviderName') {
      setBeneficiaryServiceProviderFrom((prevState: any) => ({
        ...prevState,
        mobiliserName: {
          ...prevState.mobiliserName,
          value: '',
          id: '',
          isError: false,
          message: '',
        }
      }));
      const ufTaggedId = option.find((item: any) => item.id === id);
      setUfId(ufTaggedId.ufTaggedId)
    }
        setBeneficiaryServiceProviderFrom((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id: id,
        code: code,
        isError: false,
        message: '',
      },
    }));
    }
    const handleFacilityDetailsFormChange = (value: any, key: string, id: any, option: any, code: any,) => {
        setFacilityDetailsChanged(true);
          setBeneficiaryFacilityDetailsForm((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id: id,
        code: code,
        isError: false,
        message: '',
      },
    }));
    }

    useEffect(() => {
        const pvtgData = beneficiary?.is_pvtg_classified ? buttonNames.yes : buttonNames.no;
        if (beneficiary?.alternate_mob !== beneficiaryPersonalDetailsForm.aNumber.value || beneficiary?.category_name !== beneficiaryPersonalDetailsForm.caste.value ||
            (beneficiaryPersonalDetailsForm.caste.value === 'ST' && (pvtgData !== beneficiaryPersonalDetailsForm.pvtg.value)) || beneficiary?.enroll_for_sms !== beneficiaryPersonalDetailsForm.sms.value ||
            beneficiary?.spouse_name !== beneficiaryPersonalDetailsForm.sName.value) {
            dispatch(isBeneficiaryModified(true))
        }
        else if (isImageModified) {
            dispatch(isBeneficiaryModified(true))
        }
        else {
            dispatch(isBeneficiaryModified(false))
        }
    }, [beneficiaryPersonalDetailsForm, isImageModified
    ])
    const fetchHealthProviderData = async (facilityId:string) => {
    const Health_provider = await getDataWithCache<any>(`${endpoints.getHealthProviderTagged(facilityId)}`);
    const HealthProvider = Health_provider?.data?.map((key: any) => ({
      value: `${key.f_name} ${key.l_name}`,
      label: `${key.f_name} ${key.l_name}`,
      id: key.user_id,
      code: key.user_code,
      ufTaggedId: key.uf_tagged_id
    }));
    setBeneficiaryServiceProviderData((prevState: any) => {
      return {
        ...prevState,
        ['healthProviderName']: {
          ...prevState['healthProviderName'],
          '#options': HealthProvider
        }
      }
    })

    if (userDetail?.usertype_name === 'Facility Level User' || Health_provider?.data.length === 1) {
      const loggedInUserName=(userDetail?.first_name + ' ' + userDetail?.middle_name + ' ' + userDetail?.last_name);
      const healthProviderData = Health_provider?.data.find((item: any) => `${item.f_name} ${item.l_name}` === loggedInUserName.replace('null', '').replace('  ', ' '));
      if (healthProviderData) {
        setBeneficiaryServiceProviderFrom((prevState: any) => ({
          ...prevState,
          ['healthProviderName']: {
            ...prevState['healthProviderName'],
            value: healthProviderData?.f_name + ' ' + healthProviderData?.l_name,
            id: healthProviderData?.user_id
          }
        }))
        const AshaName = await getDataWithCache<any>(`${endpoints.getMobiliserTagged(healthProviderData.uf_tagged_id)}`);
        const Ashaname = AshaName?.data.map((key: any) => ({
          value: key.f_name + " " + key.l_name,
          label: key.f_name + " " + key.l_name,
          id: key.mobiliser_id,
          code: key.user_code
        }));
        setBeneficiaryServiceProviderData((prevState: any) => {
          return {
            ...prevState,
            ['mobiliserName']: {
              ...prevState['mobiliserName'],
              '#options': Ashaname
            }
          }
        })
      }
    }
  }
   const fetchAshaData = async () => {
    const AshaName = await getDataWithCache<any>(`${endpoints.getMobiliserTagged(ufId)}`);
    const Ashaname = AshaName?.data.map((key: any) => ({
      value: key.f_name + " " + key.l_name,
      label: key.f_name + " " + key.l_name,
      id: key.mobiliser_id,
      code: key.user_code
    }));
    setBeneficiaryServiceProviderData((prevState: any) => {
      return {
        ...prevState,
        ['mobiliserName']: {
          ...prevState['mobiliserName'],
          '#options': Ashaname
        }
      }
    })
  }
  const fetchWardVillageData = async () => {
    const ufIdData = facilityDetails?.find((item: any) => item.facility_name === beneficiaryFacilityDetailsForm.facilityName.value);
    if (urbanRural === 'urban') {
      const wardData =ufIdData?.uf_id && await getDataWithCache<any>(`${endpoints.getWardByUfId(ufIdData?.uf_id)}`);
      const ward_options = wardData?.data[0]?.map((key: any) => ({
        value: key.ward_name + "-" + key.ward_code,
        label: key.ward_name + "-" + key.ward_code,
        id: key.ward_id
      }))
      setBeneficiaryPersonalDetailsData((prevState: any) => {
        return {
          ...prevState,
          ['ward']: {
            ...prevState['ward'],
            '#options': ward_options
          },
          ['village']: {
            ...prevState['village'],
            '#isDisabled': true,
          }
        }
      })
    }
    else {
      const villageData =ufIdData?.uf_id && await getDataWithCache<any>(`${endpoints.getVillageByUfId(ufIdData.uf_id)}`);
      const village_options = villageData?.data[0].map((key: any) => ({
        value: key.village_name + "-" + key.village_code,
        label: key.village_name + "-" + key.village_code,
        id: key.village_id
      }))
      setBeneficiaryPersonalDetailsData((prevState: any) => {
        return {
          ...prevState,
          ['village']: {
            ...prevState['village'],
            '#options': village_options,

          },
          ['ward']: {
            ...prevState['ward'],
            '#isDisabled': true
          }
        }
      })
    }
  }
  useEffect(() => {
    if (facilityDetailsChanged && beneficiaryFacilityDetailsForm.facilityName.value !== '' && beneficiaryFacilityDetailsForm.facilityName.value !== undefined && beneficiaryFacilityDetailsForm.facilityName.value) {
       fetchHealthProviderData(beneficiaryFacilityDetailsForm.facilityName.id);
      fetchWardVillageData();
    }
  }, [beneficiaryFacilityDetailsForm.facilityName.value])
  useEffect(() => {
    if (!isBenefHasFacilityData && !isBenefHasServiceData && beneficiaryServiceProviderForm.healthProviderName.value !== '' && beneficiaryServiceProviderForm.healthProviderName.value !== undefined &&
      ufId !== '' && ufId !== undefined
    ) {
      fetchAshaData();
    }
  }, [ufId])
    const handleVerifyButton = () => {
        dispatch(setBeneficiaryGender(beneficiaryDetails?.gender_name));
        setShowRedgOptionBeneficiary(true);
    }
    const abhaNumberSetting = async (abhaNumber: string, mobileNumber?:string| null, abhaAddress?:string | null, benficiaryDetails?:any) => {
        const encodedNumber = encodeWithKeyAndShift(JSON.stringify({ abhaId: abhaNumber }));
        const abhaResponse = await postDataJSON<any>(`${endpoints.checkAbhaIdExist}`, { data: encodedNumber });
        const decodedResponse = JSON.parse(decodeWithKeyAndShift(abhaResponse.data));
        const abhaRes = decodedResponse[0];
        const abhaFlag = abhaRes.check_abha_id_exists;
        setIsAbhaExists(abhaFlag);
        if(!abhaFlag) {
            const benefDetails = benficiaryDetails ? benficiaryDetails : getBenfData?.[0];
            const dobParts = benefDetails?.dob?.split('-');
            const formattedDob = dobParts ? createDateString(dobParts[2], dobParts[1], dobParts[0]) : null;
            if (abhaNumber?.length > 0)
                toast.success(benef_const.beneficiaryVerifiedMessage, {
                    position: "top-center"
                })
            else
                toast.error(benef_const.somethingWentWrong, {
                    position: "top-center"
                })

            const imageResult = await prepareBeneficiaryImageForDisplay(benefDetails?.profile);
            setBeneficiaryPersonalDetailsForm((prevState: any) => ({
                ...prevState,
                name: {
                    ...prevState.name,
                    value: benefDetails?.name,
                },
                dob: {
                    ...prevState.dob,
                    value: formattedDob ? parseDobToIstDayjs(formattedDob) : prevState.dob.value,
                },
                abhaId: {
                    ...prevState.abhaId,
                    value: formatAbhaNumber(benefDetails?.abhaId) || abhaNumber,
                },
                primaryMob: {
                    ...prevState.primaryMob,
                    value: benefDetails?.mob || mobileNumber || prevState.primaryMob.value,
                },
                abhaAddress:{
                    ...prevState.abhaAddress,
                    value: benefDetails?.address || abhaAddress,
                }
            }));
            setBeneficiaryPersonalDetailsData((prevState: any) => {
            return {
            ...prevState,
            ['number']: {
                ...prevState['number'],
                '#isDisabled': true,
                '#showEditIconInInputField': true
            },
            }
            })
            dispatch(updateChild('beneficiaryUpdateDetails', {
                name: benefDetails?.name,
                dob: formattedDob,
                primaryMob: benefDetails?.mob || mobileNumber,
            }));
            if (imageResult) {
                dispatch(updateChild('imageUrl', imageResult.imageUrl));
                dispatch(imageData(imageResult.formData));
            }
            dispatch(isImageEdited(true));
        } else {
            toast.error(benef_const.abhaLinkedErrorMessage, {
                position: "top-center"
            });
        }
        setConsentLanguageData(getBeneficiaryData?.consentLanguageID);
        dispatch(setBeneficiaryGender(''));
        dispatch(setBeneficiaryData([]));
        dispatch(setBeneficiaryAbha(''));
        dispatch(setTsnID(''));
        dispatch(setBeneficiaryMobileNumber(''))
        dispatch(setAadhar(''))
    }
    const closeBeneficiarRedgOptionModal = (option: string) => {
        setShowRedgOptionBeneficiary(false);
        if (option === benef_const.verifyOptions.abha || option === benef_const.verifyOptions.aadhar) {
            setShowAuthBeneficiary(true);
        }
        else if (option === benef_const.verifyOptions.phoneNumber) {
            setShowVerificationBeneficiary(true);
        }
        else if (option === benef_const.verifyOptions.face_Authentication) {
            // COMMENTED OUT: Skip FaceAuthenticationOptionsModal, directly open VerificationModal with creation mode
            // setShowFaceAuthOptionsModal(true);
            dispatch(setBeneficiaryRedgOption(benef_const.verifyOptions.face_Authentication));
            dispatch(setBeneficiaryAuthType('Face_Auth_Creation'));
            setShowVerificationBeneficiary(true);
        }
        else if (option === benef_const.verifyOptions.back) {
            setShowRedgOptionBeneficiary(false);

        }
    };

    const closeBeneficiarAuthModal = (authType: string) => {
        setShowAuthBeneficiary(false);
        if (authType === benef_const.verifyOptions.back) {
            setShowRedgOptionBeneficiary(true);
        }
        else if (authType !== '') {
            setShowVerificationBeneficiary(true);
        }
    };

    const closeFaceAuthOptionsModal = (authType: string) => {
        setShowFaceAuthOptionsModal(false);
        if (authType === 'back') {
            setShowRedgOptionBeneficiary(true);
        }
        else if (authType === 'Create_New_ABHA') {
            setShowVerificationBeneficiary(true);
        }
        else if (authType === 'Find_Existing_ABHA') {
            setShowVerificationBeneficiary(true);
        }
        else if (authType === '') {
            setTimeout(() => {
                dispatchFunction();
            }, 1000);
        }
    };

    const closeFaceAuthModal = async (type: string, verifiedBeneficiaryData?: any) => {
        //FACE AUTH MODAL IMPLEMENTED
        setShowFaceAuthModal(false);
        if (type === 'back') {
            if (beneficiaryStoreData?.beneficiaryAuthType === 'Face_Auth_Creation') {
                setShowVerificationBeneficiary(true);
            } else {
                setShowBenefeciaryUnderMobNoModal(true);
            }
        }
        else if (type === 'submit') {            
            setIsFaceAuthenticated(true);
            if (verifiedBeneficiaryData?.abhaId) {
                const abdmName = verifiedBeneficiaryData?.name || '';
                const beneficiaryName = beneficiaryDetails?.benf_name || '';
                const namesMatch = abdmName.trim() === beneficiaryName.trim();

                if (namesMatch) {
                    await abhaNumberSetting(
                        verifiedBeneficiaryData.abhaId.replace(/-/g, ""),
                        verifiedBeneficiaryData.mobile || verifiedBeneficiaryData.mob,
                        verifiedBeneficiaryData.address,
                        verifiedBeneficiaryData
                    );
                } else {
                    setAbdmDataForReAuth(verifiedBeneficiaryData);
                    setShowReAuthModal(true);
                }
            } else {
                errorLogger('Face Auth Edit: No verified beneficiary data received');
            }
        }
        else if (type === 'close') {
            setTimeout(() => {
                dispatchFunction();
            }, 1000);
        }
    };

    const handleReAuthModalClose = async (confirmed: boolean) => {
        setShowReAuthModal(false);
        
        if (confirmed && abdmDataForReAuth) {
            await abhaNumberSetting(
                abdmDataForReAuth.abhaId.replace(/-/g, ""),
                abdmDataForReAuth.mobile || abdmDataForReAuth.mob,
                abdmDataForReAuth.address,
                abdmDataForReAuth
            );
        } else {
            setAbdmDataForReAuth(null);
        }
    };

    const closeBeneficiaryExistModal =async (type:string, abhaNumber?:string, mobileNumber?:any, abhaAddress?:any, beneficiaryDetails?:any) =>{
      setShowExistsModal(false);
      if(type === 'yes'){
        if(beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.phoneNumber){
          setShowOTP(true);
        }
        else if(beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.face_Authentication){
          setShowOTP(true);
        }
        else if(beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.aadhar && beneficiaryStoreData.beneficiaryAuthType === benef_const.verifyOptions.otp){
          setShowOTP(true);
        }
        else if(beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.aadhar && beneficiaryStoreData.beneficiaryAuthType === benef_const.verifyOptions.demographics){
          if (abhaNumber) {
            abhaNumberSetting(abhaNumber.replace(/-/g, ""), mobileNumber, abhaAddress, beneficiaryDetails);
          }
        }
        else if(beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.abha){
          if (abhaNumber) {
            abhaNumberSetting(abhaNumber.replace(/-/g, ""), mobileNumber, abhaAddress, beneficiaryDetails);
          }
        }
      }else if (type === 'back') {
        if(beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.phoneNumber){
          setShowVerificationBeneficiary(true);
        }
        else if(beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.face_Authentication){
          setShowVerificationBeneficiary(true);
        }
        else if(beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.aadhar && beneficiaryStoreData.beneficiaryAuthType === benef_const.verifyOptions.otp)
        {
          setShowVerificationBeneficiary(true)  
        }
        else if(beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.aadhar && beneficiaryStoreData.beneficiaryAuthType === benef_const.verifyOptions.demographics)
        {
          setShowVerificationBeneficiary(true);
        }
        else if(beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.abha){
          setShowRedgOptionBeneficiary(true);
          setTimeout(() => {
            dispatch(setBeneficiaryRedgOption(''));
            dispatch(setBeneficiaryAuthType(''));
          }, 1000);
        }
      }
      else if(type === benef_const.verifyOptions.backToOtherMethod){
        setShowRedgOptionBeneficiary(true);
        setTimeout(() => {
          dispatch(setBeneficiaryRedgOption(''));
          dispatch(setBeneficiaryAuthType(''));
        }, 1000);
      }
      else {
        setShowDemographicModal(false);
        setTimeout(() => {
          dispatch(setBeneficiaryGender(''));
          dispatch(setBeneficiaryRedgOption(''));
          dispatch(setBeneficiaryAuthType(''));
        }, 1000);
      }
    }

    const closeVerificationBeneficiary = (type: string) => {
        setShowVerificationBeneficiary(false);

        switch (type) {
            case 'face-auth-complete':
                setShowBenefeciaryUnderMobNoModal(true);
                break;
                
            case benef_const.verifyOptions.submit:
                if (beneficiaryStoreData?.beneficiaryAuthType === 'Face_Auth_Creation') {
                    setShowFaceAuthModal(true);
                } else if (
                    beneficiaryStoreData.beneficiaryAuthType === benef_const.verifyOptions.otp ||
                    beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.phoneNumber ||
                    beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.face_Authentication ||
                    beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.abha
                ) {
                    setShowOTP(true);
                } else if (beneficiaryStoreData.beneficiaryAuthType === benef_const.verifyOptions.demographics) {
                    setShowDemographicModal(true);
                }
                break;

            case benef_const.verifyOptions.back:
                if (beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.phoneNumber) {
                    setShowRedgOptionBeneficiary(true);
                } else if (beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.face_Authentication) {
                    // COMMENTED OUT: Skip FaceAuthOptionsModal, go back to RedgeOptionModal
                    // setShowFaceAuthOptionsModal(true);
                    setShowRedgOptionBeneficiary(true);
                } else if (
                    beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.aadhar ||
                    beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.abha
                ) {
                    setShowAuthBeneficiary(true);
                }
                break;
            case benef_const.verifyOptions.showExistModal:
                setShowExistsModal(true);
                break;
            default:
                setTimeout(() => {
                    dispatchFunction()
                }, 1000);
                break;
        }
    };

    const closeDemographicModal = (type: string, abhaNumber: string, mob?:string, abhaAddress?:string, benfData?:any) => {
        setShowDemographicModal(false);

        switch (type) {
            case benef_const.verifyOptions.submit:
                abhaNumberSetting(abhaNumber.replace(/-/g, ""), mob, abhaAddress, benfData);
                break;

            case benef_const.verifyOptions.back:
                setShowVerificationBeneficiary(true);
                break;

            case benef_const.verifyOptions.backToOtherMethod:
                setShowRedgOptionBeneficiary(true);
                setTimeout(() => {
                    dispatch(setBeneficiaryRedgOption(''));
                    dispatch(setBeneficiaryAuthType(''));
                }, 1000);
                break;
            case benef_const.verifyOptions.showExistModal:
                setShowExistsModal(true);
                break;
            default:
                setTimeout(() => {
                    dispatchFunction()
                }, 1000);
                break;
        }
    };

    const closeOTPModal = (type: string, abhaNumber?: string, mob?:string, abhaAddress?:string, benefDetails?:any) => {
        setShowOTP(false);

        switch (type) {
            case benef_const.verifyOptions.close:
                setTimeout(() => {
                    dispatchFunction()
                }, 1000);
                break;

            case benef_const.verifyOptions.back:
                setShowVerificationBeneficiary(true);
                break;

            case benef_const.verifyOptions.submit:
                if (beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.phoneNumber) {
                    setShowBenefeciaryUnderMobNoModal(true);
                } else if (beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.face_Authentication) {
                    setShowBenefeciaryUnderMobNoModal(true);
                } else if (
                    beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.aadhar ||
                    beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.abha
                ) {
                    abhaNumberSetting(abhaNumber?.replace(/-/g, "") || "", mob, abhaAddress, benefDetails);
                }
                break;
            case benef_const.verifyOptions.showExistModal:
                setShowExistsModal(true);
                break;
            case benef_const.verifyOptions.backToOtherMethod:
                setShowRedgOptionBeneficiary(true);
                setTimeout(() => {
                    dispatch(setBeneficiaryRedgOption(''));
                    dispatch(setBeneficiaryAuthType(''));
                }, 1000);
                break;

            default:
                break;
        }
    };

    const closeBenefeciaryUnderMobNoModal = (type: string) => {
        setShowBenefeciaryUnderMobNoModal(false);

        switch (type) {
            case benef_const.verifyOptions.back:
                setShowVerificationBeneficiary(true);
                break;

            case benef_const.verifyOptions.submit:
                if (beneficiaryStoreData.beneficiaryRedgeOption === benef_const.verifyOptions.face_Authentication) {
                    setShowFaceAuthModal(true);
                } else if (getBenfData?.length > 0 && getBenfData[0]) {
                    abhaNumberSetting(getBenfData[0]?.abhaId?.replace(/-/g, ""), getBenfData[0]?.mob, getBenfData[0]?.address, getBenfData[0]);
                }
                break;

            default:
                setTimeout(() => {
                    dispatchFunction()
                }, 1000);
                break;
        }
    };

    const dispatchFunction = async () => {
        dispatch(setBeneficiaryGender(''));
        dispatch(setBeneficiaryRedgOption(''));
        dispatch(setBeneficiaryAuthType(''));
    }


    const onHandleSave = async () => {
        const isError: boolean[] = [];
        {
            const beneficiaryPersonalDetailsError = {
                ...beneficiaryPersonalDetailsForm
            };
            let isBeneficiaryDetailsFormError = false;
            Object.keys(beneficiaryPersonalDetailsError).map((item) => {
                if (item === 'sName') {
                    if (!beneficiaryPersonalDetailsError.sName.value) {
                        isBeneficiaryDetailsFormError = true;
                        beneficiaryPersonalDetailsError.sName.isError = true;
                        beneficiaryPersonalDetailsError.sName.message = 'Spouse name cannot be kept blank. Enter a valid spouse name.';

                    }
                    else if (!/^[a-zA-Z\s]+$/.test(beneficiaryPersonalDetailsError.sName.value)) {
                        isBeneficiaryDetailsFormError = true;
                        beneficiaryPersonalDetailsError.sName.isError = true;
                        beneficiaryPersonalDetailsError.sName.message = 'Entered spouse name is invalid. Number & Special characters are not allowed.';
                    }
                    else if (beneficiaryPersonalDetailsError.sName.value.length > 100) {
                        isBeneficiaryDetailsFormError = true;
                        beneficiaryPersonalDetailsError.sName.isError = true;
                        beneficiaryPersonalDetailsError.sName.message = 'Entered spouse name length is invalid. Max 100 characters are allowed.';
                    }
                    else {
                        beneficiaryPersonalDetailsError.sName.isError = false;
                    }
                }
                if (item === 'pvtg' && beneficiaryPersonalDetailsData.pvtg) {
                    if (!beneficiaryPersonalDetailsError.pvtg.value) {
                        isBeneficiaryDetailsFormError = true;
                        beneficiaryPersonalDetailsError.pvtg.isError = true;
                        beneficiaryPersonalDetailsError.pvtg.message = 'Is PVTG Classified cannot be empty. Choose either Yes or No.';
                    }
                    else {
                        beneficiaryPersonalDetailsError.pvtg.isError = false;
                    }
                }
                if (item === 'primaryMob' && beneficiaryPersonalDetailsError?.primaryMob?.value) {
                    if (beneficiaryPersonalDetailsError?.primaryMob?.value?.length !== 0) {
                        if (!/^\d+$/.test(beneficiaryPersonalDetailsError?.primaryMob?.value)) {
                            isBeneficiaryDetailsFormError = true;
                            beneficiaryPersonalDetailsError.primaryMob.isError = true;
                            beneficiaryPersonalDetailsError.primaryMob.message = "Phone number contains invalid characters. Enter a valid phone number."
                        }else if (beneficiaryPersonalDetailsError?.primaryMob?.value?.length !== 10) {
                            isBeneficiaryDetailsFormError = true;
                            beneficiaryPersonalDetailsError.primaryMob.isError = true;
                            beneficiaryPersonalDetailsError.primaryMob.message = 'Mobile number must contain 10 digits. Enter a valid mobile number.';
                        }
                    }
                    else {
                        beneficiaryPersonalDetailsError.primaryMob.isError = false;
                    }
                }
                if (item === 'aNumber' && beneficiaryPersonalDetailsError.aNumber.value) {
                    if (beneficiaryPersonalDetailsError.aNumber.value.length !== 0) {
                        if (!/^\d+$/.test(beneficiaryPersonalDetailsError.aNumber.value)) {
                            isBeneficiaryDetailsFormError = true;
                            beneficiaryPersonalDetailsError.aNumber.isError = true;
                            beneficiaryPersonalDetailsError.aNumber.message = "Phone number contains invalid characters. Enter a valid phone number.";
                        }else if(beneficiaryPersonalDetailsError.aNumber.value.length !== 10) {
                            isBeneficiaryDetailsFormError = true;
                            beneficiaryPersonalDetailsError.aNumber.isError = true;
                            beneficiaryPersonalDetailsError.aNumber.message = 'Mobile number must contain 10 digits. Enter a valid mobile number.';
                        }
                    }
                    else {
                        beneficiaryPersonalDetailsError.aNumber.isError = false;
                    }
                }
                if (item === 'other_religion' && beneficiaryPersonalDetailsData.other_religion["#isDisabled"] === false) {
                    if (beneficiaryPersonalDetailsForm.Religion.value !== 'Others') {
                        beneficiaryPersonalDetailsError.other_religion.isError = false;
                    }
                    if (!beneficiaryPersonalDetailsError.other_religion?.value) {
                        isBeneficiaryDetailsFormError = true;
                        beneficiaryPersonalDetailsError.other_religion.isError = true;
                        beneficiaryPersonalDetailsError.other_religion.message = 'Enter the details other religion';
                    }
                    else {
                        beneficiaryPersonalDetailsError.other_religion.isError = false;
                    }
                }
                if (item === 'abhaAddress' && beneficiaryPersonalDetailsData.abhaAddress["#isVisible"] === true && beneficiaryPersonalDetailsData.abhaAddress["#required"] === true) {
                    if (!beneficiaryPersonalDetailsError.abhaAddress?.value) {
                        isBeneficiaryDetailsFormError = true;
                        beneficiaryPersonalDetailsError.abhaAddress.isError = true;
                        beneficiaryPersonalDetailsError.abhaAddress.message = 'Abha Address cannot be empty.';
                    }
                    else {
                        beneficiaryPersonalDetailsError.abhaAddress.isError = false;
                    }
                }
            
            setBeneficiaryPersonalDetailsForm(beneficiaryPersonalDetailsError);
            isError[0] = isBeneficiaryDetailsFormError;
            })
            const beneficiaryServiceProviderFormError = {
            ...beneficiaryServiceProviderForm
            };
             let isBeneficiaryServiceProviderFormError = false;
            Object.keys(beneficiaryServiceProviderFormError).map((item) => {
              if (item === 'healthProviderName') {
                if ((!beneficiaryServiceProviderFormError.healthProviderName?.value || beneficiaryServiceProviderFormError.healthProviderName.value === 'Select') && beneficiaryServiceProviderData.healthProviderName['#required']) {
                  isBeneficiaryServiceProviderFormError = true;
                  beneficiaryServiceProviderFormError.healthProviderName.isError = true;
                  beneficiaryServiceProviderFormError.healthProviderName.message = 'Select a valid Health Provider Name from the dropdown';
                } else {
                  beneficiaryServiceProviderFormError.healthProviderName.isError = false;
                }
              }
              setBeneficiaryServiceProviderFrom(beneficiaryServiceProviderFormError);
              isError[1] = isBeneficiaryServiceProviderFormError;
            })
            const beneficiaryFacilityFormError = {
              ...beneficiaryFacilityDetailsForm
            };
            let isBeneficiaryFacilityFormError = false;
            Object.keys(beneficiaryFacilityFormError).map((item) => {
              if (item === 'facilityName') {
                if (!beneficiaryFacilityFormError.facilityName?.value) {
                  isBeneficiaryFacilityFormError = true;
                  beneficiaryFacilityFormError.facilityName.isError = true;
                  beneficiaryFacilityFormError.facilityName.message = 'Select a valid facility name from the dropdown';
                } else {
                  beneficiaryFacilityFormError.facilityName.isError = false;
                }
              }
              if (item === 'facilityType') {
                if ((!beneficiaryFacilityFormError.facilityType?.value || beneficiaryFacilityFormError.facilityType.value === 'Select') && beneficiaryFacilityDetailsData.facilityType['#required']) {
                  isBeneficiaryFacilityFormError = true;
                  beneficiaryFacilityFormError.facilityType.isError = true;
                  beneficiaryFacilityFormError.facilityType.message = 'Select a valid facility type from the dropdown';
                } else {
                  beneficiaryFacilityFormError.facilityType.isError = false;
                }
              }
              setBeneficiaryFacilityDetailsForm(beneficiaryFacilityFormError);
              isError[2] = isBeneficiaryFacilityFormError;
            })
        }
        if (isError[0] === false && isError[1] === false && isError[2] === false) {
            const abhaVerified = (beneficiary?.abha_id ?? '') !== (beneficiaryPersonalDetailsForm?.abhaId?.value ?? '');
            const abhaAddress = beneficiaryPersonalDetailsData?.abhaAddress?.['#type'] === 'InputFieldWithSuffix' ? `${beneficiaryPersonalDetailsForm?.abhaAddress?.value}${beneficiaryPersonalDetailsData?.abhaAddress?.['#suffix']}` : `${beneficiaryPersonalDetailsForm?.abhaAddress?.value}`
            const payload = {
                benefId: beneficiary.benef_id,
                genderId: beneficiaryDetails.gender_id,
                abhaId: beneficiaryPersonalDetailsForm.abhaId.value,
                beneficiaryName: beneficiaryPersonalDetailsForm?.name?.value || beneficiary?.benf_name,
                beneficiaryDob: formatDobForApi(
                    beneficiaryPersonalDetailsForm?.dob?.value,
                    beneficiary?.dob),
                primaryMob: beneficiaryPersonalDetailsForm.primaryMob.value,
                abhaAddress: abhaAddress,
                spouseName: beneficiaryPersonalDetailsForm.sName.value,
                religionId: beneficiaryPersonalDetailsForm.Religion.id,
                otherReligion: beneficiaryPersonalDetailsForm.other_religion.value,
                categoryId: beneficiaryPersonalDetailsForm.caste.id ? beneficiaryPersonalDetailsForm.caste.id : null,
                alternateMob: beneficiaryPersonalDetailsForm.aNumber.value,
                healthProviderId: beneficiaryServiceProviderForm.healthProviderName.id ? [beneficiaryServiceProviderForm.healthProviderName.id] : [],
                mobiliserId: beneficiaryServiceProviderForm.mobiliserName.id ? [beneficiaryServiceProviderForm.mobiliserName.id] : [],
                isMobiliseChanged: initialMobiliserId === beneficiaryServiceProviderForm.mobiliserName.id ? false : true,
                isHealthProviderChanged: initialHealthProviderId === beneficiaryServiceProviderForm.healthProviderName.id ? false : true,
                isPvtgClassified: beneficiaryPersonalDetailsForm.caste.value !== 'ST' ? null : beneficiaryPersonalDetailsForm.pvtg.value === 'Yes' ? true : false,
                enrollForSms: beneficiaryPersonalDetailsForm.sms.value,
                effectiveFromDt: null,
                wardId: beneficiary?.ward_id,
                villageId: beneficiary?.village_id,
                facilityId: beneficiaryFacilityDetailsForm?.facilityName.id,
                parentUserId: userId,
                isBenfMigrated: beneficiary?.is_migrated,
                isVerifiedInRCH2: abhaVerified,
                abhaVerified: abhaVerified,
                parentUserTypeId: null,
                parentRoleId: null,
                consentTemplateDetails:consentLanguageData? consentLanguageData.map((item:any)=>({consent_template_id:item.consent_template_id})): null,
                isFaceAuthenticated: isFaceAuthenticated,
                reverificationProcessId: loginId
            }
            try {
                let abhaFlag = false;   
                if(!isAbhaExists) {
                    const encodedNumber = encodeWithKeyAndShift(JSON.stringify({ abhaId: beneficiaryPersonalDetailsForm.abhaId.value }));
                    const abhaResponse = await postDataJSON<any>(`${endpoints.checkAbhaIdExist}`, { data: encodedNumber });
                    const decodedResponse = JSON.parse(decodeWithKeyAndShift(abhaResponse.data));
                    const abhaRes = decodedResponse[0];
                    abhaFlag = abhaRes.check_abha_id_exists;
                    if(!abhaFlag || beneficiary?.abha_id) {
                        await updateBenf(payload);
                    }
                } else {
                  if (!abhaFlag) {
                    await updateBenf(payload);
                  } else {
                    toast.error(benef_const.abhaLinkedErrorMessage, {
                      position: 'top-center',
                    });
                  }
                }
                              
                dispatch(updateForm("file", null));
                dispatch(isImageEdited(false));
                dispatch(isBeneficiaryModified(false));
                dispatch(imageData(''));
                dispatch(setBeneficiaryRedgOption(''));
                dispatch(setBeneficiaryAuthType(''));
                dispatch(setAbhaAddress(''));
                dispatch(setTxnIdForAbhaAddress(''));
            }
            catch (error: any) {
                errorLogger(error?.response?.data || error?.response || error)
            }

        }
    }

    const updateBenf = async (payload:any) => {
      const encodedPayload = encodeWithKeyAndShift(JSON.stringify(payload));
      const response = await putDataJSON<any>(
        `${endpoints.updateBeneficiary}`,
        { data: encodedPayload },
      );
      if (isImageModified) {
        try {
          if (imageDetails) {
            if (imageDetails instanceof FormData) {
              imageDetails.append('imageType', 'beneficiary_profile');
              imageDetails.append('objectId', beneficiary.benef_id);
            }
            const responses = await axios.post(
              `${endpoints.beneficiaryImageUpload}`,
              imageDetails,
              Auth.loggedInWithMultipart(),
            );
          }
        } catch (error: any) {
          errorLogger(error?.response?.data || error?.response || error);
        }
      }

      toast.success(benef_const.benfUpdatedSuccessfully, {
        position: 'top-center',
      });
      beneficiaryReduxStoreRemovalUtils(dispatch);
      navigate('/beneficiaries');
    };
    const onMobileNumberEditIconClick = () => {
        setShowEditMobileNumberModal(true);
    }
    const handleCloseEditMobileNumber = () => {
        setShowEditMobileNumberModal(false);
    }
    const handleSubmitEditMobileNumber = (newMobileNumber: number) => {
        setBeneficiaryPersonalDetailsForm((prevState: any) => ({
            ...prevState,
            primaryMob: {
                ...prevState.primaryMob,
                value: newMobileNumber?.toString(),
            },
        }))
        setShowEditMobileNumberModal(false);
    }
    return (<>
        {showUnauthorized ? <Unauthorised /> :
            <div className="beneficiary_create">
                <div className="edit_beneficiary">
                    <BadgesComponent
                        className="over-badge"
                        badgeName="Personal Details"
                        variant="primary-1"
                        badgeType="case5"
                    />
                    <div className="edit_beneficiary">
                        <div className="create_beneficiary_page">
                            <BeneficiaryRedgeOptionModal showModal={showRedgOptionBeneficiary} handleClose={closeBeneficiarRedgOptionModal} showTempRegistration={false} />
                            <AuthenticationOptionModal showModal={showAuthBeneficiary} handleClose={closeBeneficiarAuthModal} />
                            <FaceAuthenticationOptionsModal showModal={showFaceAuthOptionsModal} handleClose={closeFaceAuthOptionsModal} />
                            <FaceAuthenticationModal showModal={showFaceAuthModal} handleClose={closeFaceAuthModal} />
                            <ReAuthenticationModal 
                                showModal={showReAuthModal} 
                                handleClose={handleReAuthModalClose}
                                beneficiaryData={beneficiaryDetails}
                                abdmData={abdmDataForReAuth}
                                isBenfVerification={true}
                            />
                            <VerificationModal showModal={showVerificationBeneficiary} handleClose={closeVerificationBeneficiary} setLinkedBenefDetails={setLinkedBenefDetails}/>
                            <OTPVerification showModal={showOTP} handleClose={closeOTPModal} setLinkedBenefDetails={setLinkedBenefDetails}/>
                            <Demographic showModal={showDemographicModal} handleClose={closeDemographicModal} setLinkedBenefDetails={setLinkedBenefDetails}/>
                            <BenefeciaryUnderMobNo showModal={showBenefeciaryUnderMobNoModal} handleClose={closeBenefeciaryUnderMobNoModal} />
                            <BeneficiaryExistsModal showModal={showExistsModal} handleClose={closeBeneficiaryExistModal} linkedBenefDetails={linkedBenefDetails} setLinkedBenefDetails={setLinkedBenefDetails}/>
                            <form className="edit_container_page">
                                <CommonFormFields
                                    formData={beneficiaryPersonalDetailsData}
                                    formState={beneficiaryPersonalDetailsForm}
                                    handleFormChange={handlePersonalDetailsFormChange}
                                    onInputFieldEditIconClick={onMobileNumberEditIconClick}
                                />
                                <div className='migrated_temp_beneficiary_abha_verify_button'>
                                    <Button
                                        onClick={handleVerifyButton}
                                        disabled={beneficiaryPersonalDetailsForm.abhaId.value ? true : false}
                                        buttonName={'Verify'}
                                        colorType={''}
                                        id={''}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <hr></hr>
                <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
                    <div className="edit_beneficiary">
                        <BadgesComponent
                            className="over-badge"
                            badgeName="Service Provider"
                            variant="primary-1"
                            badgeType="case5"
                        />
                        <div className="edit_beneficiary">
                            <div className="edit_service_provider">
                                <form className="edit_container_page">
                                    <CommonFormFields
                                        formData={beneficiaryServiceProviderData}
                                        formState={beneficiaryServiceProviderForm}
                                        handleFormChange={handleServiceDetailsFormChange}
                                    />
                                </form>
                            </div>
                        </div>
                    </div>
                    <span style={{ borderLeft: "1px solid #8080805e", height: "100px" }}></span>
                    <div className="edit_beneficiary">
                        <BadgesComponent
                            className="over-badge"
                            badgeName="Facility Details"
                            variant="primary-1"
                            badgeType="case5"
                        />
                        <div className="edit_beneficiary">
                            <div className="edit_facility_details">
                                <form className="edit_container_page">
                                    <CommonFormFields
                                        formData={beneficiaryFacilityDetailsData}
                                        formState={beneficiaryFacilityDetailsForm}
                                        handleFormChange={handleFacilityDetailsFormChange}
                                    />
                                </form>
                            </div>
                        </div>
                    </div>
                    {showEditMobileNumberModal &&
                        <BeneficiaryMobileNumberUpdation
                            showModal={showEditMobileNumberModal}
                            handleClose={handleCloseEditMobileNumber}
                            handleSubmit={handleSubmitEditMobileNumber}
                            oldMobileNumber={oldMobileNumber}
                            showOnlyTextFieldModal={false}
                        />}
                </div>

            </div>}
    </>)
})
BeneficiaryEdit.displayName = 'BeneficiaryEdit'
export default BeneficiaryEdit;